function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "o2hdhzpdia",
  width: "108.5%",
  height: "134.7%",
  x: "-4.3%",
  y: "-12.4%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 10,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 10
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0.203921569 0 0 0 0 0.278431373 0 0 0 0 0.388235294 0 0 0 0.0575010927 0"
})), /*#__PURE__*/React.createElement("rect", {
  id: "usxy5n85jb",
  width: 820,
  height: 202,
  x: 0,
  y: 0,
  rx: 4
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#FCFCFC",
  d: "M0 0H1440V2484H0z",
  transform: "translate(-952 -816)"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-952 -816) translate(310 827)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#o2hdhzpdia)",
  xlinkHref: "#usxy5n85jb"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#usxy5n85jb"
}))), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M0 0H1440V2484H0z",
  opacity: 0.299,
  transform: "translate(-952 -816)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-952 -816) translate(429 793)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 582,
  height: 726,
  fill: "#FFF",
  rx: 4
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(518 18)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 34,
  height: 34,
  fill: "#FFF",
  stroke: "#F8F8FB",
  rx: 17
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H24V24H0z",
  transform: "translate(5 5)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#344763",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M5 12L19 12",
  transform: "translate(5 5) rotate(45 12 12)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#344763",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M5 12L19 12",
  transform: "translate(5 5) rotate(-45 12 12)"
}))))));

function SvgCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.be01251e.svg";
export { ForwardRef as ReactComponent };